import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import HeroBanner from '../components/AboutUs/HeroBanner'
import TimeLine from '../components/AboutUs/TimeLine'
import Philosophy from '../components/AboutUs/Philosophy'
import Journey from '../components/AboutUs/Journey'
import OLMPromise from '../components/AboutUs/OLMPromise'
import MeetTheTeam from '../components/AboutUs/MeetTheTeam'
import CoreValues from '../components/AboutUs/CoreValues'
import Marketing from '../components/AboutUs/Marketing'
import Footer from '../components/Footer'

export default function AboutUs({ data }) {
    return (
        <div>
            <Header meta={data?.yoast_head} />
            <HeroBanner />
            <TimeLine />
            <Philosophy />
            <Journey />
            <OLMPromise />
            <MeetTheTeam />
            <CoreValues />
            <Marketing />
            <Footer />
        </div>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/about')
    const data = page ? page[0] : {}

    return {
        props: {
            data,
        },
        revalidate: 10, // In seconds
    }
}
